/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  // Input,
  Modal,
  Input,
  TreeSelect,
} from 'antd';
// import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
// import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
// import ModalDelete from 'components/ModalDelete';
// import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  // ESTATUS_INACTIVO,
  // ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  CRUDclavePresupuestal,
  findInTree,
  formatDataTreeFuentesFinanciamiento,
  // findInTree,
  formatTreeSelectData,
  ModelClavesPresupuestalesDeIngreso,
  normalizeCRI,
  normalizeCuentasContables, normalizeDataAreas,
  normalizeFuentesFinanciamiento,
} from 'api/configuraciones/clavesPresupuestalesDeIngresos';
// import makeTree from 'utils/makeTree';
import { useSelector } from 'react-redux';
import makeTree from 'utils/makeTree';
import { makeTreeCog, mapWithKeys, normalizeCog } from 'api/configuraciones/clavesPresupuestalesDeEgresos';
import { getSegmentosDeConfiguracion, segmentoAplica } from 'utils/segmentosPresupuestales';

export const clavesPresupuestalesPermission = {
  permissionModel: 'clavepresupuestal',
  catalogsModels: [],
  tabsModels: [],
};

const ClavesPresupuestalesSAC = ({
  permission, ingresoValues, egresoValues, configurador,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  // const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  // undefined = cargando; null = sin configuración de segmentos (se muestran todas las columnas)
  const [segmentos, setSegmentos] = useState(undefined);
  // const [selectedData, setSelectedData] = useState({});

  const [periodoFiscal, setPeriodoFiscal] = useState([]);
  const entidad = useSelector(({ auth }) => auth.entidad);
  const [areas, setAreas] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [clasificacionesAdministrativas, setClasificacionesAdministrativas] = useState();
  const [clasificacionesFuncionales, setClasificacionesFuncionales] = useState();
  const [clasificacionesProgramaticas, setClasificacionesProgramaticas] = useState();
  const [destinosPresupuestales, setDestinosPresupuestales] = useState([]);
  const [funcionesPresupuestales, setFuncionesPresupuestales] = useState([]);
  const [clases, setClases] = useState([]);
  const [tiposDeGasto, setTiposDeGasto] = useState();
  const [fuentesFinanciamiento, setFuentesFinanciamiento] = useState([]);
  const [listaFuentes, setListaFuentes] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [catalogoCuentasContables, setCatalogoCuentasContables] = useState();
  const [planDeCuentas, setPlanDeCuentas] = useState();
  const [cogs, setCogs] = useState([]);
  const [conceptosDeIngresos, setConceptosDeIngresos] = useState([]);
  const [estados, setEstados] = useState([]);

  // const [cogs, setCogs] = useState([]);

  // const registroName = '';
  const cliente = CRUDclavePresupuestal;
  const {
    nameModel,
    // nameModelSingular,
  } = ModelClavesPresupuestalesDeIngreso;

  // const formInstances = [
  //   form,
  // ];

  // const fetchData = async () => {
  //   setLoading(true);
  //   const _data = await cliente.obtenerListaDeRegistros();
  //   setData(formatReceived(_data));
  //   setLoading(false);
  // };

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const {
        _ejercicioFiscal,
        _areas,
        _destinosPresupuestales,
        _programas,
        _proyectos,
        _funcionesPresupuestales,
        _clasificacionAdministrativa,
        _clasificacionFuncional,
        _clasificacionProgramatica,
        _cogs,
        _tiposDeGastos,
        _fuentesFinanciamientos,
        _tipoDeNominaEmpleado,
        _planDeCuentas,
        _catalogoCuentasContables,
        _estados,
      } = egresoValues;
      const _data = await cliente.obtenerListaDeRegistros({
        configuracion_de_segmento_presupuestal: configurador?.id,
      });
      setPeriodoFiscal(_ejercicioFiscal);
      const formattedURS = formatTreeSelectData(normalizeDataAreas(_areas));
      setAreas(formattedURS);
      setDestinosPresupuestales(_destinosPresupuestales);
      setProgramas(_programas);
      setProyectos(_proyectos);
      setFuncionesPresupuestales(_funcionesPresupuestales);
      setClasificacionesAdministrativas(mapWithKeys(_clasificacionAdministrativa));
      setClasificacionesFuncionales(mapWithKeys(_clasificacionFuncional));
      setClasificacionesProgramaticas(mapWithKeys(_clasificacionProgramatica));
      setCogs(normalizeCog(makeTreeCog(_cogs)));
      setTiposDeGasto(_tiposDeGastos);

      const fuentesTree = makeTree(_fuentesFinanciamientos);
      const normalized = normalizeFuentesFinanciamiento(fuentesTree);

      setFuentesFinanciamiento(formatDataTreeFuentesFinanciamiento(normalized));
      setListaFuentes(_fuentesFinanciamientos);

      setTiposNominasEmpleados(_tipoDeNominaEmpleado);
      const normalizedCuentas = normalizeCuentasContables(
        _catalogoCuentasContables,
      );
      const normalizedPlanCuentas = normalizeCuentasContables(
        _planDeCuentas,
      );
      setPlanDeCuentas(normalizedPlanCuentas);
      setCatalogoCuentasContables(normalizedCuentas);
      setEstados(_estados);
      setData(formatReceived(_data));
      setLoading(false);
    };
    if (!egresoValues
      || typeof egresoValues !== 'object'
      || Object.keys(egresoValues).length === 0) {
      return;
    }
    fetchAll();
  }, [egresoValues]);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const {
        _ejercicioFiscal,
        _conceptosIngresos,
        _areas,
        _cri,
        _fuentesClasificacion,
        _planDeCuentas,
        _catalogoCuentasContables,
        _estados,
      } = ingresoValues;
      const _data = await cliente.obtenerListaDeRegistros({
        configuracion_de_segmento_presupuestal: configurador?.id,
      });
      setEstados(_estados);
      setData(formatReceived(_data));
      setPeriodoFiscal(_ejercicioFiscal);
      const formattedURS = formatTreeSelectData(normalizeDataAreas(_areas));
      setAreas(formattedURS);
      setConceptosDeIngresos(_conceptosIngresos);
      setClases(normalizeCRI(_cri));

      const fuentesTree = makeTree(_fuentesClasificacion);
      const normalized = normalizeFuentesFinanciamiento(fuentesTree);

      setListaFuentes(_fuentesClasificacion);
      setFuentesFinanciamiento(formatDataTreeFuentesFinanciamiento(normalized));

      const normalizedCuentas = normalizeCuentasContables(
        _catalogoCuentasContables,
      );
      const normalizedPlanCuentas = normalizeCuentasContables(
        _planDeCuentas,
      );
      setPlanDeCuentas(normalizedPlanCuentas);
      setCatalogoCuentasContables(normalizedCuentas);
      setLoading(false);
    };
    if (!ingresoValues
      || typeof ingresoValues !== 'object'
      || Object.keys(ingresoValues).length === 0) {
      return;
    }
    fetchAll();
  }, [ingresoValues]);

  const onCancel = () => {
    setVisible(false);
    // setVisibleAutorizar(false);
    // setDisableFields(false);
    setSelectedRowKeys([]);
    // setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _nivelDeEstudio = await cliente.obtenerUnRegistro(match.id);
    setTimeout(() => {
      if (_nivelDeEstudio) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_nivelDeEstudio));
          // setDisableFields(_nivelDeEstudio?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    // setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  // const onFinish = async () => {
  //   try {
  //     setLoading(true);
  //     await form.validateFields();
  //     const values = form.getFieldsValue();
  //     const [key] = selectedRowKeys;
  //     // eslint-disable-next-line max-len
  //     const saved =
  //     await (key ? cliente.actualizarRegistro(key, values) : cliente.crearRegistro(values));
  //     if (saved) {
  //       if (!key) {
  //         handleOnRowClick(saved);
  //       } else {
  //         onCancel();
  //       }
  //       await fetchData();
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(
  //       err,
  //       setLoading,
  //       formInstances,
  //     );
  //   }
  // };

  // const deleteItem = async () => {
  //   try {
  //     setLoading(true);
  //     if (selectedRowKeys.length) {
  //       const [key] = selectedRowKeys;
  //       const deleted = await cliente.borrarRegistro(key);
  //       if (deleted) {
  //         setVisibleAlert(false);
  //         onCancel();
  //         await fetchData();
  //       }
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(err, setLoading);
  //   }
  // };

  // const handleKeyPress = (e) => {
  //   if (/\d/.test(e.key)) {
  //     e.preventDefault();
  //   }
  // };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  // const onClickAdd = () => {
  //   form.resetFields();
  //   onCancel();
  //   setVisible(true);
  // };

  // const onClickDelete = () => {
  //   const [key] = selectedRowKeys;
  //   if (key) {
  //     setVisibleAlert(true);
  //   } else {
  //     setVisibleAlert(false);
  //     message.warn('Este campo no se puede borrar');
  //   }
  // };

  // const onConfirmAutorizar = async () => {
  //   try {
  //     setLoading(true);
  //     const [key] = selectedRowKeys;
  //     if (!key) {
  //       setLoading(false);
  //       onCancel();
  //       onSuccess({}, 'No se puede autorizar un Nivel de Estudios ya autorizado');
  //       return;
  //     }
  //     const saved = await cliente.autorizarRegistro(key);
  //     if (saved) {
  //       await fetchData();
  //       onCancel();
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(err, setLoading);
  //   }
  // };

  const columnsIngreso = [
    {
      titleText: 'Concepto de Ingreso',
      dataIndex: 'concepto_de_ingreso',
      key: 'concepto_de_ingreso',
      width: 200,
      render: (val) => (conceptosDeIngresos.find((e) => e.id === val)?.descripcion),
    },
    {
      titleText: 'Clasificador por Rubro de Ingresos',
      dataIndex: 'cri',
      key: 'cri',
      width: 300,
      render: (val) => {
        const found = findInTree(clases, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area',
      key: 'directorio_de_area',
      width: 150,
      render: (val) => {
        const found = findInTree(areas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_financiamiento',
      key: 'fuente_financiamiento',
      width: 260,
      render: (val) => {
        const fuente = listaFuentes?.find((f) => f.id === val);
        return fuente ? `${fuente.clave} - ${fuente.nombre}` : val;
      },
    },
    {
      titleText: 'Plan de Cuentas',
      dataIndex: 'cuenta_contable_conac',
      key: 'cuenta_contable_conac',
      width: 250,
      render: (val) => {
        const found = findInTree(planDeCuentas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 250,
      render: (val) => {
        const found = findInTree(catalogoCuentasContables, val);
        return found ? found.title : val;
      },
    },
  ];

  useEffect(() => {
    let mounted = true;
    // El administrador de pestañas inicia `configurador` como {} mientras lo consulta.
    const cargando = configurador && !configurador.id && !Object.keys(configurador).length;
    if (cargando) return undefined;
    const fetchSegmentos = async () => {
      const _segmentos = await getSegmentosDeConfiguracion(configurador?.id);
      if (mounted) setSegmentos(_segmentos);
    };
    fetchSegmentos();
    return () => { mounted = false; };
  }, [configurador]);

  const columnsEgreso = [
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area',
      key: 'directorio_de_area',
      width: 150,
      render: (val) => {
        const found = findInTree(areas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Destino Presupuestal',
      dataIndex: 'destino_presupuestal',
      key: 'destino_presupuestal',
      width: 200,
      render: (val) => (destinosPresupuestales?.find((e) => e.id === val)?.nombre),
    },
    {
      titleText: 'Programa',
      dataIndex: 'programa',
      key: 'programa',
      width: 200,
      render: (val) => {
        const item = programas?.find((e) => e.id === val);
        return (item ? `${item.clave} - ${item.descripcion}` : '');
      },
    },
    {
      titleText: 'Proyecto',
      dataIndex: 'proyecto',
      key: 'proyecto',
      width: 200,
      render: (val) => {
        const item = proyectos?.find((e) => e.id === val);
        return (item ? `${item.clave} - ${item.descripcion}` : '');
      },
    },
    {
      titleText: 'Función Presupuestal',
      dataIndex: 'funcion_presupuestal',
      key: 'funcion_presupuestal',
      width: 200,
      render: (val) => {
        const item = funcionesPresupuestales?.find((e) => e.id === val);
        return (item ? `${item.numero} - ${item.nombre}` : '');
      },
    },
    {
      titleText: 'Clasificación Administrativa',
      dataIndex: 'clasificacion_administrativa',
      key: 'clasificacion_administrativa',
      width: 250,
      render: (val) => {
        const found = findInTree(clasificacionesAdministrativas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Clasificación Funcional',
      dataIndex: 'clasificacion_funcional',
      key: 'clasificacion_funcional',
      width: 250,
      render: (val) => {
        const found = findInTree(clasificacionesFuncionales, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Clasificación Programática',
      dataIndex: 'clasificacion_programatica',
      key: 'clasificacion_programatica',
      width: 300,
      render: (val) => {
        const found = findInTree(clasificacionesProgramaticas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Clasificador por Objeto del Gasto',
      dataIndex: 'clasificador_de_objeto_de_gasto',
      key: 'clasificador_de_objeto_de_gasto',
      render: (val) => {
        const found = findInTree(cogs, val);
        return found ? found.title : val;
      },
      width: 300,
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_financiamiento',
      key: 'fuente_financiamiento',
      width: 260,
      render: (val) => {
        const fuente = listaFuentes?.find((f) => f.id === val);
        return fuente ? `${fuente.clave} - ${fuente.nombre}` : val;
      },
    },
    {
      titleText: 'Tipo de Gasto',
      dataIndex: 'tipo_de_gasto',
      key: 'tipo_de_gasto',
      width: 200,
      render: (val) => (tiposDeGasto?.find((e) => e.id === val)?.nombre),
    },
    {
      titleText: 'Tipo de Nómina-Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (val) => {
        const _tipoNominaEmpleado = tiposNominasEmpleados.find((e) => e.id === val);
        return _tipoNominaEmpleado?.descripcion;
      },
    },
    {
      titleText: 'Plan de Cuentas',
      dataIndex: 'cuenta_contable_conac',
      key: 'cuenta_contable_conac',
      width: 250,
      render: (val) => {
        const found = findInTree(planDeCuentas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 250,
      render: (val) => {
        const found = findInTree(catalogoCuentasContables, val);
        return found ? found.title : val;
      },
    },
  ];

  const columns = [
    {
      titleText: 'Ejercicio',
      dataIndex: 'periodo_fiscal',
      key: 'periodo_fiscal',
      width: 150,
      render: (val) => (periodoFiscal.find((e) => e.id === val)?.periodo),
    },
    ...(segmentoAplica(segmentos, 'identificador_geografico') ? [{
      titleText: 'Identificador Geográfico',
      dataIndex: 'identificador_geografico',
      key: 'identificador_geografico',
      width: 200,
    }] : []),
    ...(ingresoValues ? columnsIngreso : []),
    ...(egresoValues
      ? columnsEgreso.filter((col) => segmentoAplica(segmentos, col.dataIndex))
      : []),
    {
      titleText: 'Clave Presupuestal Completa',
      dataIndex: 'clave_completa',
      key: 'clave_completa',
      width: 250,
    },
    {
      titleText: 'Clave Presupuestal Corta',
      dataIndex: 'clave_visible',
      key: 'clave_visible',
      width: 250,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };
  const formsIngreso = (
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="periodo_fiscal"
          rules={[{ required: true, message: 'Se Requiere Ejercicio Fiscal' }]}
          label="Ejercicio"
          hasFeedback
        >
          <Select
            labelProp="periodo"
            allowClear
            disabled
            dataSource={periodoFiscal}
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="identificador_geografico"
          rules={[{ required: true, message: 'Seleccione el Identificador Geográfico' }]}
          label="Identificador Geográfico"
          hasFeedback
          initialValue={
            entidad?.identificador_geografico ?? 0
          } // cambiar identificador geografico
        >
          <Input disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="configuracion_presupuestal"
          label="Segmento Presupuestal"
          hasFeedback
          initialValue={configurador?.identificador}
        >
          <Input
            disabled
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="cri"
          rules={[{ required: true, message: 'Seleccione la Clasificación Funcional' }]}
          label="Clasificador por Rubro de Ingresos"
          hasFeedback
        >
          <TreeSelect
            showSearch
            key="key"
            treeData={clases}
            disabled
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="directorio_de_area"
          label="Área"
          rules={rules.required}
          hasFeedback
        >
          <TreeSelect
            showSearch
            treeNodeFilterProp="title"
            treeData={areas}
            disabled
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fuente_financiamiento"
          label="Fuente de Financiamiento"
          rules={[{ required: true, message: 'Seleccione una fuente de financiamiento' }]}
        >
          <TreeSelect
            showSearch
            treeNodeFilterProp="title"
            style={{ width: '100%' }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={fuentesFinanciamiento}
            disabled
            allowClear
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="cuenta_contable_conac"
          rules={[{ required: true, message: 'Seleccione el Plan de Cuentas' }]}
          label="Plan de cuentas"
          hasFeedback
        >
          <TreeSelect
            showSearch
            treeNodeFilterProp="title"
            treeData={planDeCuentas}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="cuenta_contable"
          rules={[{ required: true, message: 'Seleccione el Tipo de Nómina' }]}
          label="Cuenta Contable"
          hasFeedback
        >
          <TreeSelect
            showSearch
            treeNodeFilterProp="title"
            treeData={catalogoCuentasContables}
            disabled
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="estados_globales"
          label="Estatus"
          rules={rules.required}
          hasFeedback
        >
          <Select
            labelProp="descripcion"
            keyProp="id"
            dataSource={estados}
            disabled
          />
        </Form.Item>
      </Col>
      <Form.Item hidden>
        <Button htmlType="submit" />
      </Form.Item>
    </Row>
  );

  // Solo se muestran los segmentos que la configuración presupuestal marca con "Aplica".
  const aplica = (campo) => segmentoAplica(segmentos, campo);

  const formsEgreso = (
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="periodo_fiscal"
          rules={[{ required: true, message: 'Se Requiere Ejercicio Fiscal' }]}
          label="Ejercicio"
          hasFeedback
        >
          <Select
            labelProp="periodo"
            allowClear
            disabled
            dataSource={periodoFiscal}
          />
        </Form.Item>
      </Col>

      {aplica('identificador_geografico') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="identificador_geografico"
            rules={[{ required: true, message: 'Seleccione el Identificador Geográfico' }]}
            label="Identificador Geográfico"
            hasFeedback
            initialValue={entidad?.pais}
          >
            <Input disabled />
          </Form.Item>
        </Col>
      )}
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="configuracion_presupuestal"
          label="Segmento Presupuestal"
          hasFeedback
          initialValue={configurador?.identificador}
        >
          <Input
            disabled
          />
        </Form.Item>
      </Col>
      {aplica('directorio_de_area') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="directorio_de_area"
            label="Área"
            rules={rules.required}
            hasFeedback
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              treeData={areas}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('destino_presupuestal') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="destino_presupuestal"
            label="Destino Presupuestal"
            rules={rules.required}
            hasFeedback
          >
            <Select
              dataSource={destinosPresupuestales}
              keyProp="id"
              labelProp="nombre"
              render={(item) => `${item.numero || ''} - ${item.nombre}`}
              allowClear
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('programa') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="programa"
            rules={[{ required: true, message: 'Seleccione el Programa' }]}
            label="Programa"
            hasFeedback
          >
            <Select
              keyLabelRender
              render={(item) => (item ? `${item.clave} - ${item.nombre}` : '')}
              dataSource={programas}
              allowClear
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('proyecto') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="proyecto"
            rules={[{ required: true, message: 'Seleccione el Proyecto' }]}
            label="Proyecto"
            hasFeedback
          >
            <Select
              keyLabelRender
              labelProp="nombre"
              render={(item) => (item ? `${item.clave} - ${item.nombre}` : '')}
              dataSource={proyectos}
              allowClear
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('funcion_presupuestal') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="funcion_presupuestal"
            label="Función Presupuestal"
            rules={rules.required}
            hasFeedback
          >
            <Select
              dataSource={funcionesPresupuestales}
              keyProp="id"
              labelProp="nombre"
              render={(item) => `${item.numero || ''} - ${item.nombre}`}
              allowClear
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('clasificacion_administrativa') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clasificacion_administrativa"
            rules={[{ required: true, message: 'Seleccione la Clasificación Administrativa' }]}
            label="Clasificación Administrativa"
            hasFeedback
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              treeData={clasificacionesAdministrativas}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('clasificacion_funcional') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clasificacion_funcional"
            rules={[{ required: true, message: 'Seleccione la Clasificación Funcional' }]}
            label="Clasificación Funcional"
            hasFeedback
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              treeData={clasificacionesFuncionales}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('clasificacion_programatica') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clasificacion_programatica"
            rules={[{ required: true, message: 'Seleccione la Clasificación Programática' }]}
            label="Clasificación Programática"
            hasFeedback
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              treeData={clasificacionesProgramaticas}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('clasificador_de_objeto_de_gasto') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item name="clasificador_de_objeto_de_gasto" hidden>
            <Input />
          </Form.Item>
          {/* El árbol de COG usa rutas como valor, así que se muestra el texto del nodo */}
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => (
              <Form.Item label="Clasificador por Objeto del Gasto">
                <Input
                  disabled
                  value={findInTree(cogs, getFieldValue('clasificador_de_objeto_de_gasto'))?.title}
                />
              </Form.Item>
            )}
          </Form.Item>
        </Col>
      )}
      {aplica('tipo_de_gasto') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="tipo_de_gasto"
            rules={[{ required: true, message: 'Seleccione el Tipo de Gasto' }]}
            label="Tipo de Gasto"
            hasFeedback
          >
            <Select
              labelProp="nombre"
              allowClear
              disabled
              dataSource={tiposDeGasto}
            />
          </Form.Item>
        </Col>
      )}
      {aplica('fuente_financiamiento') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="fuente_financiamiento"
            label="Fuente de Financiamiento"
            rules={[{ required: true, message: 'Seleccione una fuente de financiamiento' }]}
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              treeData={fuentesFinanciamiento}
              disabled
              allowClear
            />
          </Form.Item>
        </Col>
      )}
      {aplica('tipo_de_nomina_empleado') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            label="Tipo de Nómina Empleado"
            name="tipo_de_nomina_empleado"
          >
            <Select
              keyProp="id"
              labelProp="descripcion"
              dataSource={tiposNominasEmpleados}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('cuenta_contable_conac') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="cuenta_contable_conac"
            rules={[{ required: true, message: 'Seleccione el Plan de Cuentas' }]}
            label="Plan de Cuentas"
            hasFeedback
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              treeData={planDeCuentas}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      {aplica('cuenta_contable') && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="cuenta_contable"
            rules={[{ required: true, message: 'Seleccione la Cuenta Contable' }]}
            label="Cuenta Contable"
            hasFeedback
          >
            <TreeSelect
              showSearch
              treeNodeFilterProp="title"
              treeData={catalogoCuentasContables}
              disabled
            />
          </Form.Item>
        </Col>
      )}
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="estados_globales"
          label="Estatus"
          rules={rules.required}
          hasFeedback
        >
          <Select
            labelProp="descripcion"
            keyProp="id"
            dataSource={estados}
            disabled
          />
        </Form.Item>
      </Col>
      <Form.Item hidden>
        <Button htmlType="submit" />
      </Form.Item>
    </Row>
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            // onClickAdd,
            onClickExpand: () => onClickEdit(),
            // onClickDelete,
          }}
          // customActions={[
          //   {
          //     onClick: () => setVisibleAutorizar(true),
          //     icon: <CheckCircleOutlined />,
          //     text: 'Autorizar',
          //     disabledBySelection: true,
          //     disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
          //     className: 'success',
          //   },
          // ]}
          disableDelete
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width="90%"
          title={(
            <FormSubmitControls
              // label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} ${nameModel}`}
              label={`Visualizar ${nameModel}`}
              // onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            // allowSave={!disableFields}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            // onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            {ingresoValues && (formsIngreso)}
            {egresoValues && (formsEgreso)}

          </Form>

        </Modal>
        {/* <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`${nameModelSingular} ${registroName}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar ${nameModelSingular} ${registroName}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle={`Inactivar ${nameModelSingular} ${registroName}`}
          loading={loading}
        /> */}
      </Spin>
    </Row>
  );
};

export default ClavesPresupuestalesSAC;
